export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14821.74e626b3.jpg";